import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { BackendApiService } from '../../../app/services/backend-api.service';

@Component({
  selector: 'app-clients-subscription',
  standalone: true,
  imports: [MatIconModule, CommonModule, FormsModule],
  templateUrl: './clients-subscription.component.html',
  styleUrls: ['./clients-subscription.component.scss'] // Fixed: should be styleUrls (plural)
})
export class ClientsSubscriptionComponent implements OnInit {
  constructor(private service: BackendApiService) {}

  public subscriptionLoading: boolean = true;
  public subscriptionData: any[] = [];
  public filteredSubscriptionData: any[] = [];
  public viewMode: 'grid' | 'list' = 'grid';
  public generatingKey: { [key: number]: boolean } = {};
  public searchQuery: string = '';
  public searchFocused: boolean = false;

  ngOnInit(): void {
    this.fetchSubscriptionData();
  }

  async fetchSubscriptionData() {
    try {
      this.subscriptionLoading = true;
      const result: any = await this.service.getDataV2(BaseUrlConstantsService.GET_SUBSCRIPTION_DATA);
      if (result.status === "success" && result.subscriptions.length > 0) {
        this.subscriptionData = result.subscriptions;
        this.filteredSubscriptionData = [...this.subscriptionData];
        console.log('Subscription data fetched successfully:', this.subscriptionData);
      } else {
        this.subscriptionData = [];
        this.filteredSubscriptionData = [];
      }
    } catch (error) {
      console.error('Error fetching subscription data:', error);
      this.subscriptionData = [];
      this.filteredSubscriptionData = [];
    } finally {
      this.subscriptionLoading = false;
    }
  }

  toggleViewMode() {
    this.viewMode = this.viewMode === 'grid' ? 'list' : 'grid';
  }

  onSearchQueryChange() {
    if (!this.searchQuery.trim()) {
      this.filteredSubscriptionData = [...this.subscriptionData];
      return;
    }

    const query = this.searchQuery.toLowerCase().trim();
    this.filteredSubscriptionData = this.subscriptionData.filter(client =>
      (client.full_name && client.full_name.toLowerCase().includes(query)) ||
      (client.email && client.email.toLowerCase().includes(query)) ||
      (client.company_name && client.company_name.toLowerCase().includes(query)) ||
      (client.subscription_flag && client.subscription_flag.toLowerCase().includes(query)) ||
      (client.phone_no && client.phone_no.includes(query))
    );
  }

  clearSearch() {
    this.searchQuery = '';
    this.filteredSubscriptionData = [...this.subscriptionData];
  }

  onSearchFocus() {
    this.searchFocused = true;
  }

  onSearchBlur() {
    this.searchFocused = false;
  }

  async generateSubscriptionKey(clientId: number) {
    try {
      this.generatingKey[clientId] = true;
      const result: any = await this.service.postData(
        BaseUrlConstantsService.GENERATE_SUBSCRIPTION_KEY,
        { client_id: clientId, clientType: "EXPIRE" }
      );

      console.log('Generated subscription key:', result);

      if(result.status === "success" && result.token?.length > 0) {
        const clientIndex = this.subscriptionData.findIndex(c => c.clientId === clientId);
        if (clientIndex !== -1) {
          // Update the client data
          this.subscriptionData[clientIndex] = {
            ...this.subscriptionData[clientIndex],
            subscription_key: result.token,
            active: 1,
            subscription_flag: this.getNewSubscriptionFlag(
              this.subscriptionData[clientIndex].subscription_flag
            )
          };

          // Update filtered data to reflect changes
          const filteredIndex = this.filteredSubscriptionData.findIndex(c => c.clientId === clientId);
          if (filteredIndex !== -1) {
            this.filteredSubscriptionData[filteredIndex] = {
              ...this.filteredSubscriptionData[filteredIndex],
              ...this.subscriptionData[clientIndex]
            };
          }
        }
      }
    } catch (error) {
      console.error('Error generating subscription key:', error);
    } finally {
      this.generatingKey[clientId] = false;
    }
  }

  private getNewSubscriptionFlag(currentFlag: string): string {
    switch(currentFlag) {
      case 'NEW':
      case 'EXPIRED':
        return 'ACTIVE';
      case 'PENDING RENEW':
        return 'RENEWED';
      default:
        return currentFlag;
    }
  }

  getStatusBadgeClass(subscriptionFlag: string): string {
    switch (subscriptionFlag?.toUpperCase()) {
      case 'TRIAL': return 'status-trial';
      case 'NEW': return 'status-new';
      case 'ACTIVE': return 'status-active';
      case 'EXPIRED': return 'status-expired';
      case 'PENDING RENEW': return 'status-pending-renew';
      case 'RENEWED': return 'status-renewed';
      default: return 'status-default';
    }
  }

  getDaysLeftColor(daysLeft: number | null): string {
    if (daysLeft === null || daysLeft === undefined) return 'text-red-400';
    if (daysLeft <= 0) return 'text-red-400';
    if (daysLeft <= 7) return 'text-amber-400';
    if (daysLeft <= 15) return 'text-blue-400';
    return 'text-emerald-400';
  }
}
